/**
 *
 * Layout
 *
 * layout.scene
 *
 * layout.mouse
 * layout.keyboard
 * layout.dragHelper
 *
 */

import * as THREE from "three"
import Model from "../model/Model"
import DragHelper from "./DragHelper"
import Mouse from './input/Mouse'
import Keyboard from './input/Keyboard'
import Select from "./input/Select";
//import SelectRender from "./objects/SelectRender";
// TODO: OrbitControls import three.js on its own, so the webpack bundle includes three.js twice!
//import OrbitControls from "orbit-controls-es6";

//import OrbitControls from "../../node_modules/three/examples/jsm/controls/OrbitControls";
//import OrbitControls from "three-orbitcontrols"
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

import Stats from "stats-js";
//var TransformControls = require('three-transform-controls')(THREE)
import TransformControls from "three-transform-controls";
import Picture from "../bitmap/Picture";
import Grid from "../model/Grid";
import Mask from "../bitmap/Mask";
import Dat from 'dat.gui'
import init from 'three-dat.gui' // Import initialization method
init(Dat) // Init three-dat.gui with Dat

// rendering performance issues
//import CCapture from 'ccapture.js' // npm issue https://github.com/spite/ccapture.js/issues/78
//let CCapture = window.CCapture
//import CCapture from '/public/app/ccapture.min'


export default class Layout {

    constructor(parameters) {

        /**
         * store vertices array per grid index when a dot is hit for history purposes
         * @type {Array}
         * @private
         */
        this._memory_grid_vertices = []

        this.callbackMouseUp = null

        if (typeof (parameters.div_id) == 'undefined') {
            console.log('layout: error, tool object missing')
            return
        }

        this._is3D = (typeof (parameters.is_3d) == 'undefined') ? false : parameters.is_3d

        if (typeof (parameters.div_id) == 'undefined') {
            console.log('layout: div_id parameter unset, default div id value for scene : ' + this.div_id)
        }

        this.tool = null || parameters.tool
        this.transformControls = null
        this.div_id = parameters.div_id || 'scene'

        if (this._is3D)   // 2d or 3d
            this.set3D()
        else
            this.set2D()

        this.select = new Select()

        this.layerActive = 0

        this.dotDisplay = (typeof (parameters.dot_display) == 'undefined') ? false : parameters.dot_display

        this.parameters = {
            dot: {
                size: 8,
                color: 0x007700
            },
            background: {
                color: 0xffffff
            }
        }

        this.parameters = { ...this.parameters, ...parameters }

        this.debug = (typeof (this.parameters.debug) !== 'undefined') ? this.parameters.debug : false

        this.status = {
            dragging: false
        }

        // store model layers for rendering
        this.model = new Model()


        this.container  // contains the div

        this.renderer

        this.raycaster

        this.dragHelper = null

        this.controls

        this.scene

        this.mouse = this.keyboard = null

        this.capturer = false

        this.init()

        if ((typeof (parameters.helpers) == 'undefined') ? true : parameters.helpers) {
            this.setupHelpers()
            this.log('helpers activated, remove with helpers parameter')
        }




    }




    /**
     * getMemoryGridVertices
     *
     * populated by this.handleMouseDown() if hit
     * used by History object
     *
     * @param index
     * @return {*}
     */
    getMemoryGridVertices(index = this.getLayerActive()) {

        if (typeof (this._memory_grid_vertices[index]) !== 'undefined') {

            return this._memory_grid_vertices[index]

        }

    }



    //////////////////////////////////////////////////////////////////// callback

    /**
     *
     * setCallbackMouseUp
     *
     * @param f
     * @return boolean was dragging
     * @return number grid index
     */
    setCallbackMouseUp(f) {

        if (typeof (f) === 'function') {

            this.log('-> mouse : callbackMouseUp ')

            this.callbackMouseUp = f

        } else {

            this.log('-> mouse : callbackMouseUp error')

            this.callbackMouseUp = null

        }

    }

    //////////////////////////////////////////////////////////////// end callback




    /**
     * initializing
     *
     */
    init() {

        //this.setupCapturer()
        if (!this.setContainer()) {
            return false
        }
        this.setupRenderer()    // needs the container
        this.setupInput()
        this.setupScene()
        this.setupCamera()
        this.setupLights()
        this.setupControls()
        this.setupRaycaster()

        this.dragHelper = new DragHelper(
            this.camera,
            window,
            this.is3D()
        )

        //if (this.is3D())
        //this.setupHelpers()

        this.setupBindEvents()  // events

        if (this.isDebug()) {
            this.setupStats()
            //this.setupHelpers()

        }

        //this.selectObject = new SelectRender()  // @todo select ?
        //this.sceneLayer.add( this.selectObject.getObject() )

        this.render()

    }


    /**
     * logic
     *
     */


    /**
     * setPicture
     *
     * @param image
     */
    setPicture(image) {

        let loader = new THREE.TextureLoader()

        // load picture
        let texture = loader.load(image, () => {

            // picture

            let model_picture = new Picture(
                texture,
                texture.image.width,
                texture.image.height
            )

            this.model.setPicture(model_picture)

            let obj = this.scene.getObjectByName('model_picture')

            let object = this.model.getPicture()
            object.mesh.name = 'model_picture'

            // add once only
            if (!obj) {
                this.sceneAdd(object)

            } else {
                this.scene.remove(obj)
                this.sceneAdd(object)
            }

        })

    }


    /**
     * setTexture
     *
     * @param image
     * @param repeat
     */
    setTexture(image, repeat = 1) {

        let loader = new THREE.TextureLoader()

        // load image
        let texture = loader.load(image, () => {

            texture.wrapS = THREE.RepeatWrapping
            texture.wrapT = THREE.RepeatWrapping
            texture.repeat.set(repeat, repeat)

            this.model.setTexture(texture)

            //texture.dispose() // = null; // @cleanup

        })

    }



    /**
     * setModel
     *
     * @param image_mask
     * @param image_repeat
     * @param parameters
     * @param callback
     */
    setModel(image_mask, image_repeat, parameters, callback = () => { }) {

        // Object.assign({}, parameters, { >> shallow copy, not deep

        parameters = parameters || {}

        parameters.dot = parameters.dot || {
            color: 0x00ff00,
            size: 10
        }

        parameters.repeat = parameters.repeat || 10

        parameters.uv = parameters.uv || {
            u: 10,
            v: 10
        }

        // verticesJson
        parameters.import = parameters.import || null

        let loader = new THREE.TextureLoader()

        // load picture
        let texture_mask = loader.load(image_mask, () => {

            // load mask
            let mask = new Mask(
                texture_mask,
                texture_mask.image.width,
                texture_mask.image.height
            )

            if (image_repeat) {
                // load repeat
                let texture_repeat = loader.load(image_repeat, () => {

                    // load grid
                    let grid = new Grid({
                        ...{
                            texture: texture_repeat,
                            width: texture_mask.image.width,
                            height: texture_mask.image.height,
                            // if import is null, grid will be created automatically from image shape
                            import: parameters.import
                        }, ...parameters
                    })

                    // add mask+grid to model
                    this.model.add(mask, grid)
                    // add dots to sceneoverlay used to intercept mouse interactions
                    this.sceneOverlay.add(grid.getDots())

                    callback()

                    return true

                })
            }

        })

    }



    /**
     * 3D/2D
     *
     */
    is3D() {
        return this._is3D
    }

    set3D() {
        this._is3D = true
    }

    set2D() {
        this._is3D = false
    }



    /**
     * @todo experimental
     *
     */
    isDefinedTransformControls() {

        if (this.transformControls !== null)
            return true

        return false

    }



    /**
     * move objects / scene
     * https://threejs.org/examples/misc_controls_transform.html
     */
    setupTransformController() {

        //TransformControls new??

        this.transformControls = new TransformControls(this.camera, this.renderer.domElement)
        //this.transformControls.addEventListener('change', () => { console.log(0) })//.bind(this)
        //this.transformControls.attach( selected_item )
        //this.transformControls.detach()
        //this.transformControls.setMode( "rotate" ) // scale rotate translate

        this.scene.add(this.transformControls)

    }


    /**
     * sets mouse Orbit Controls for 2D or 3D (this.is3D())
     */
    setupControls() {

        //console.log('debug', this.renderer.domElement)

        this.controls = new OrbitControls(
            this.camera,
            this.renderer.domElement
        )

        // this.controls.enableDamping = true
        // this.controls.dampingFactor = 0.25
        this.controls.enableZoom = true
        this.controls.enablePan = true

        // this.controls.minZoom = 0.5;
        // this.controls.maxZoom = 1;

        this.controls.enabled = true
        this.controls.maxDistance = 3500

        this.controls.minDistance = 0
        this.controls.autoRotate = false //true

        this.controls.enableKeys = !true

        this.controls.enableRotate = !false;

        //this.controls.screenSpacePanning = true;

        //    this.controls.enableRotate = false

        this.controls.keys = {
            LEFT: 37, //left arrow
            UP: 38, // up arrow
            RIGHT: 39, // right arrow
            BOTTOM: 40 // down arrow
        }

        this.controls.touches = {
            ONE: THREE.TOUCH.DOLLY_PAN
        }

        if (this._is3D) {

            this.controls.mouseButtons = {
                LEFT: THREE.MOUSE.ROTATE,
                MIDDLE: THREE.MOUSE.DOLLY,
                RIGHT: THREE.MOUSE.PAN
            }

        } else

            this.controls.mouseButtons = {
                RIGHT: THREE.MOUSE.PAN,
                MIDDLE: THREE.MOUSE.DOLLY,
                LEFT: THREE.MOUSE.PAN
            }

        // this.controls.enableDamping = true; // For that slippery Feeling
        // this.controls.dampingFactor = 0.12; // Needs to call update on render loop
        this.controls.rotateSpeed = .5; // Rotate speed

        //this.controls.autoRotateSpeed = 0.08; // 30
        this.controls.maxPolarAngle = Math.PI / 2; // Don't let to go below the ground

        //this.controls.keyPanSpeed = 30

    }



    /**
     *          SCREEN
     *
     *
     *
     *
     *
     *
     */



    /**
     * Convert screen coordinates into Normalized Device Coordinates [-1, +1].
     * @see https://learnopengl.com/Getting-started/Coordinate-Systems
     *
     * @param event
     * @param debug
     * @returns {*[]}
     */
    getNDCCoordinates(event, debug) {

        const {
            clientHeight,
            clientWidth,
            offsetLeft,
            offsetTop,
        } = this.renderer.domElement

        const xRelativePx = event.clientX - offsetLeft
        const x = (xRelativePx / clientWidth) * 2 - 1

        const yRelativePx = event.clientY - offsetTop
        const y = -(yRelativePx / clientHeight) * 2 + 1

        if (debug) {

            const data = {
                "Screen Coords (px)": { x: event.screenX, y: event.screenY },
                "Canvas-Relative Coords (px)": { x: xRelativePx, y: yRelativePx },
                "NDC (adimensional)": { x, y },
            }

            //console.table(data, ["x", "y"])

        }

        return [x, y]

    }



    /**
     *
     * @param xNDC
     * @param yNDC
     * @returns {*[]}
     */
    getScreenCoordinates(xNDC, yNDC) {

        const {
            clientHeight,
            clientWidth,
            offsetLeft,
            offsetTop,
        } = this.renderer.domElement

        const xRelativePx = ((xNDC + 1) / 2) * clientWidth
        const yRelativePx = -0.5 * (yNDC - 1) * clientHeight
        const xScreen = xRelativePx + offsetLeft
        const yScreen = yRelativePx + offsetTop
        return [xScreen, yScreen]

    }



    /**
     * Rendering performance stats - debug
     */
    setupStats() {

        this.stats = new Stats()
        this.stats.showPanel(0)
        this.stats.domElement.style.cssText = 'position:absolute;bottom:40px;left:64px;'

        this.container.appendChild(this.stats.domElement)

    }



    /**
     * log (if debug)
     * @param m message
     * @param o output
     */
    log(m, o) {

        if (this.debug) {
            if (o || o === false)
                console.log(m, o)
            else
                console.log(m)

        }

    }


    /**
     * this.scene.add wrapper : get mesh
     * @param object
     */
    sceneAdd(object) {

        if ('getMesh' in object) {

            this.scene.add(object.getMesh())

            this.log('sceneAdd :', object.mesh.name || 'no name')


        } else {

            this.log('sceneAdd error', object)

        }

    }


    /**
     * activate 3D after init
     */
    activate3D() {

        this.set3D()
        this.setupControls()
        this.setupHelpers()
        //this.setupStats()

    }


    /**
     * activate 2D after init
     */
    activate2D() {

        this.set2D()
        //this.setupControls()
        //this.setupHelpers()
        //this.setupStats()

    }







    event(category, label, value) {

        /*window.gtag('event', 'app_' + store.user.uid, {
            'event_category': category,
            'event_label': label,
            'value': value
        })*/

    }

    isDebug() {

        return this.debug

    }


    setLayerActive(index) {

        if (index >= 0 && index < this.model.getSize())

            this.layerActive = index

    }


    getLayerActive() {

        return this.layerActive

    }


    getModelGrid(index = this.layerActive) {

        return this.model.getGrid(index)

    }


    getModel() {

        return this.model

    }










    //////////// SETUP /////////////////////////////////////////////////

    /**
     * Mouse Keyboard
     */
    setupInput() {

        this.mouse = new Mouse({
            div_id: this.div_id,
            debug: this.debug
        })

        this.keyboard = new Keyboard({
            div_id: this.div_id,
            debug: this.debug
        })

    }



    /**
     * Container
     */
    setContainer() {

        const div = document.getElementById(this.div_id)

        if (!div) {
            console.log('error div #' + this.div_id + ' missing')
            return false
        }

        div.setAttribute('style', 'min-height:100px;')
        this.container = div

        return true

    }



    /**
     * Renderer
     */
    setupRenderer() {

        this.renderer = new THREE.WebGLRenderer({

            alpha: true,
            antialias: true,
            preserveDrawingBuffer: true, // only for saving @todo activate on the fly ?

            powerPreference: 'high-performance'

        })

        this.renderer.setPixelRatio(window.devicePixelRatio || 1)

        const { clientWidth, clientHeight } = this.container

        this.renderer.setSize(clientWidth, clientHeight)

        this.renderer.shadowMap.enabled = true

        // append renderer to container
        this.container.appendChild(this.renderer.domElement)

        //this.renderer.shadowMap.type = THREE.PCFShadowMap

    }



    /**
     * Scenes
     */
    setupScene() {

        /*this.sceneUnderlay = new THREE.Scene()
        this.sceneUnderlay.autoUpdate = true
        this.sceneUnderlay.name = 'sceneUnderlay'
        */

        this.scene = new THREE.Scene()
        this.scene.autoUpdate = true
        this.scene.name = 'scene'
        // color from css
        const color = new THREE.Color(this.parameters.background.color)
        this.scene.background = color
        this.scene.fog = null


        //this.scene.fog = new THREE.FogExp2( 0xFFFFFF,0.0001);

        /*this.sceneMask = new THREE.Scene()
        this.sceneMask.autoUpdate = true
        this.sceneMask.name = 'sceneMask'*/

        this.sceneOverlay = new THREE.Scene()
        this.sceneOverlay.autoUpdate = true
        this.sceneOverlay.name = 'sceneOverlay'

        this.sceneLayer = new THREE.Scene()
        this.sceneLayer.autoUpdate = true
        this.sceneLayer.name = 'sceneLayer'


        /*this.sceneUi = new THREE.Scene()
        this.sceneUi.autoUpdate = true
        this.sceneUi.name = 'sceneUi'*/




    }



    setupCamera() {

        const fov = 75
        const { clientWidth, clientHeight } = this.container
        const aspect = clientWidth / clientHeight
        const near = 0.1
        const far = 10000

        this.camera = new THREE.PerspectiveCamera(fov, aspect, near, far)
        this.camera.name = 'camera'

        this.camera.position.set(0, 0, 1200)

        this.camera.lookAt(this.scene.position)

    }



    setupLights() {

        const dirLight = new THREE.DirectionalLight(0xffffff, 1)
        dirLight.name = 'light'
        dirLight.position.set(120, 30, -200)
        dirLight.castShadow = true
        dirLight.shadow.camera.near = 10
        this.scene.add(dirLight)

        const spotLight = new THREE.SpotLight(0xffffff)
        spotLight.name = 'spotlight'
        spotLight.position.set(120, 30, 0)
        spotLight.castShadow = true
        dirLight.shadow.camera.near = 10
        ////this.scene.add(spotLight)

        const ambientLight = new THREE.AmbientLight(0xffffff)
        this.scene.add(ambientLight)

        //this.sceneUnderlay.add(dirLight)
        //this.sceneUnderlay.add(ambientLight)

        this.sceneOverlay.add(dirLight)
        this.sceneOverlay.add(ambientLight)

        this.sceneLayer.add(dirLight)
        this.sceneLayer.add(ambientLight)

    }


    /**
     *
     */
    setupRaycaster() {

        this.raycaster = new THREE.Raycaster()
        this.raycaster.params.Points.threshold = this.parameters.dot.size // important

    }



    handleResize(event) {

        //console.log( 'resize' , event )

        this.camera.aspect = window.innerWidth / window.innerHeight
        this.camera.updateProjectionMatrix()

        this.renderer.setSize(window.innerWidth, window.innerHeight)

    }



    /**
     * mouse
     *
     */
    handleMouseMove(event) {
        //console.log(event)

        //console.log(this.dragHelper.dragging)

        if (this.dragHelper.dragging) {

            //console.log(' block layout wdrag ')

            this.dragHelper.mouseMove(event)



            /**
             * move dot
             *
             */
            if (this.tool.isDot()) {

                // move dot

                let z = 0

                if (this.is3D())
                    z = this.dragHelper.planePoint.z

                this.grid.dot(
                    this.status.currentIndex,
                    this.dragHelper.planePoint.x,
                    this.dragHelper.planePoint.y,
                    z
                )






                // move multiple dots

                if (this.tool.isDotMultiple() && this.select.hasSelected()) {

                    // all indexes
                    for (let [dotIndex, dot] of Object.entries(this.select.getSelected())) {

                        //console.log(dotIndex, dot, '*****')

                        let x = dot.dot.x + this.mouse.dragX(),
                            y = dot.dot.y - this.mouse.dragY(),
                            z = dot.dot.z //+ this.mouse.dragZ()

                        this.grid.dot(
                            dotIndex,
                            x,
                            y,
                            z
                        )

                        this.selectObject.dotUpdate(
                            dotIndex,
                            x,
                            y,
                            z
                        )

                    }

                }







            }


            else

                /**
                 * move u or v line
                 *
                 */
                if (this.tool.isLineU() || this.tool.isLineV()) {


                    let xx, yy, zz

                    xx = this.dragHelper.mouse.delta.x
                    yy = this.dragHelper.mouse.delta.y

                    zz = 0

                    if (this.is3D())
                        zz = this.dragHelper.planePoint.z   //mouse.delta.z


                    //zz = 0 //this.dragHelper.mouse.delta.z

                    //console.log('>>> delta : ' + xx + ' ' +yy  + ' ' +zz )


                    const [u, v] = this.grid.getUV(this.status.currentIndex)

                    //console.log(u +'_'+v)

                    const vertices = this.dragHelper.getVerticeSave()

                    if (this.tool.isLineU()) {
                        this.grid.lineU(u, xx, yy, zz, vertices)
                    }

                    else if (this.tool.isLineV()) {
                        this.grid.lineV(v, xx, yy, zz, vertices)
                    }

                }




            /**
             * @dev
             */

            // move line

            /*let [u, v] = this.grid.getUV( this.status.currentIndex )

            let vertices = null // reset

            //if (this.tool.isLineU()) {
                vertices = this.grid.getLineU(u)

            console.log( vertices )

            this.dragHelper.verticeSave( vertices )

            /*this.grid.lineU(
                this.status.currentIndex ,
                this.dragHelper.planePoint.x,
                this.dragHelper.planePoint.y,
                this.dragHelper.planePoint.z,
                vertices
            )*/




            // drag
            //if (this.status.dragging && this.status.currentIndex !== null) {

            //this.controls.enabled = false




            //this.controls.enabled = true

            //}





        }
    }


    /**
     * handleMouseUp
     *
     * callback
     *
     * @param event
     */
    handleMouseUp(event) {

        // mouseup after dragging dot ?

        this.log('handleMouseUp was dragging : ' + this.mouse.isDragging() + ' on index : ' + this.status.currentIndex)

        let callback_status_dragging = this.mouse.isDragging(),
            callback_status_index = this.status.currentIndex

        this.status.currentIndex = null

        this.dragHelper.dragging = false

        this.dragHelper.currentIndex = null

        this.controls.enabled = true





        // update multiple dots selection

        if (this.tool.isDotMultiple() && this.select.hasSelected()) {

            // all indexes
            for (let [dotIndex, dot] of Object.entries(this.select.getSelected())) {

                let x = this.grid.getDot(dotIndex).x,
                    y = this.grid.getDot(dotIndex).y,
                    z = this.grid.getDot(dotIndex).z

                this.select.selectUpdate(
                    dotIndex,
                    // store actual dots coordinates
                    x,
                    y,
                    z
                )

                this.selectObject.dotUpdate(
                    dotIndex,
                    x,
                    y,
                    z
                )

            }

        }


        // callback

        if (typeof (this.callbackMouseUp) === 'function') {
            this.log('-> layout : callbackMouseUp')
            this.callbackMouseUp(
                callback_status_dragging,
                callback_status_index
            )
        }




    }


    /**
     *
     * handleMouseDown
     *
     * uses
     * hitDetection()
     * dragHelper
     * tool
     *
     * if line drag vertices are saved into dragHelper : this.dragHelper.verticeSave(vertices)
     *
     * @param event
     */
    handleMouseDown(event) {


        //console.log('*****', event)


        // locked

        if (!this.tool.isDisplayDot()) {

            this.log('handleMouseDown:locked')

            return

        }



        this.log('handleMouseDown layer active : ' + this.getLayerActive())

        //this.grid = this.model.getGrid( this.tool.getMappingActive() )
        this.grid = this.model.getGrid(this.getLayerActive())


        //const [x, y] = this.getNDCCoordinates(event, true) // super

        var mouse = new THREE.Vector2()

        //mouse.x = x
        //mouse.y = y

        mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

        this.log('handleMouseDown ( ' + mouse.x + ' , ' + mouse.y + ')')




        let intersects = this.hitDetection(mouse)

        this.log('intersects', intersects)

        //console.log(intersects,'........')


        if (intersects) {

            this.dragHelper.dragging = true

            this.controls.enabled = false

            const

                intersection = intersects[0],

                index = intersection['index']   // @todo faceIndex ? deprecation

            //console.log(intersection,index,'*********')


            /**
             *
             * history purposes
             *
             * store all vertices
             *
             */

            this._memory_grid_vertices[this.getLayerActive()]

                = this.grid.getVertices()


            this.log('->>>>>', this._memory_grid_vertices)    // debug



            // @todo in progress
            if (this.tool.isDotMultiple() && this.keyboard.isShift()) {

                if (!this.select.selectAdd(
                    index,
                    this.grid.getDot(index)
                )) {

                    // not added because already selected

                    // remove
                    this.select.selectRemove(
                        index
                    )

                    this.selectObject.dotRemove(index)



                    //console.log(this.select)

                } else {

                    // add to select render object

                    let d = this.grid.getDot(index)

                    this.selectObject.dotUpdate(index, d.x, d.y, d.z)

                }

            }













            // detect hit dot
            this.status.currentIndex = index

            this.log('handleClick : hit ' + this.status.currentIndex + ' ( ' + event.clientX + ',' + event.clientY + ' )')

            // analytics
            //this.event( 'app_mouse_down' , 'hit_' + this.status.currentIndex , this.status.currentIndex )

            this.dragHelper

                .setIndex(
                    intersects,
                    intersection['index']
                )

                // store real screen coordinates mouse click

                .mouseDown(
                    event.clientX,
                    event.clientY,
                    0
                )


            // line store

            //if (this.tool.isLineU() || this.tool.isLineV()) {

            let [u, v] = this.grid.getUV(index)

            let vertices = null // reset

            if (this.tool.isLineU()) {
                vertices = this.grid.getLineU(u)
            }

            if (this.tool.isLineV()) {
                vertices = this.grid.getLineV(v)
            }

            //console.log(vertices)

            this.dragHelper.verticeSave(vertices)

            //}


        } else {

            this.status.currentIndex = null

            this.dragHelper.dragging = false

            this.controls.enabled = true

        }

    }




    hitDetection(mouse) {

        // HIT ON sceneOverlay ? @todo refactoring

        this.raycaster.setFromCamera(mouse, this.camera)

        //let sceneOverlay = this.sceneContainer.getSceneOverlay( this.tool.getMappingActive() ).dots

        const intersects = this.raycaster.intersectObjects(
            this.sceneOverlay.children  // @todo ? sceneOverlay
        )

        if (intersects.length > 0) {

            this.log('hitDetection:true')

            return intersects

        }

        this.log('hitDetection:false')

        return false

    }



    setupBindEvents() {

        // this.handleClick = this.handleClick.bind(this)
        this.handleResize = this.handleResize.bind(this)
        this.handleMouseMove = this.handleMouseMove.bind(this)
        this.handleMouseUp = this.handleMouseUp.bind(this)
        this.handleMouseDown = this.handleMouseDown.bind(this)

        /*this.renderer.domElement.addEventListener(
            'click', this.handleClick, false
        )*/

        window.addEventListener('resize', this.handleResize, false)

        this.renderer.domElement.addEventListener(
            'pointerdown',
            this.handleMouseDown, false
        )

        this.renderer.domElement.addEventListener(
            'pointermove',
            this.handleMouseMove, false
        )

        this.renderer.domElement.addEventListener(
            'pointerup', // removed mouseup
            this.handleMouseUp, false
        )



    }



    setupHelpers() {

        const gridHelper = new THREE.GridHelper(2400, 10, 0xff0000, 0xffffff)
        gridHelper.name = "GridHelper"
        //this.sceneOverlay.add(gridHelper)

        this.scene.add(gridHelper)

        const gridHelper2 = new THREE.GridHelper(2400, 10, 0xff0000, 0xffffff)
        gridHelper2.name = "GridHelper"
        //this.sceneOverlay.add(gridHelper2)
        gridHelper2.rotation.x = Math.PI / 2

        this.scene.add(gridHelper2)

        // XYZ axes helper (XYZ axes are RGB colors, respectively)
        const axesHelper = new THREE.AxesHelper(75)
        axesHelper.name = "XYZ AzesHelper"
        //this.sceneOverlay.add(axesHelper)

        this.scene.add(axesHelper)

    }




    /**
     *
     *
     * rendering
     *
     *
     *
     */



    render() {

        if (this.isDebug()) {
            this.stats.begin()
        }


        /**
         * clear
         */
        this.renderer.clear()
        this.renderer.clearDepth()
        this.renderer.autoClear = false


        /**
         * render scene
         */
        this.renderer.render(this.scene, this.camera)


        /**
         * render model
         */
        let modelLayer

        for (let i = 0; i < this.model.getSize(); i++) {

            // rendering of mesh not scenes... ?!?.. @todo

            modelLayer = this.model.get(i)

            if (modelLayer) {

                //console.log('rendering',modelLayer)

                this._renderMaskPrepare()

                // scale test / resolution ?
                //ml.mask.getMesh().scale.set(0.5,0.5,0.5)

                //if (this.sceneContainer.isSceneMask())
                //if (modelLayer.mask.getMesh())
                this.renderer.render(modelLayer.mask.getMesh(), this.camera)

                this._renderMaskAfter()

                //if (this.sceneContainer.isScene())
                //this.renderer.render( ml.image.getMesh() , this.camera)
                //console.log(modelLayer.grid,modelLayer.grid.getMesh().material.map)
                //if (modelLayer.grid.getMesh())
                this.renderer.render(modelLayer.grid.getMesh(), this.camera)

                this._renderMaskEnd()

                if (modelLayer.grid.isDisplay()) {

                    if (this.tool.isDisplayGrid()) {

                        // display grid

                        this.renderer.render(

                            modelLayer.grid.getGridLine(),
                            this.camera

                        )

                        // display selected dots

                        if (this.dotDisplay) {


                            /*this.renderer.render(

                                this.select.getDots(),
                                this.camera

                            )*/

                            this.renderer.render(

                                modelLayer.grid.getDots(),
                                this.camera

                            )

                        }



                    }

                    //if ( this.tool.isDisplayDotGrid() ) {
                    // @A1-6 remove dots

                    // display dot if true :

                    //    this.renderer.render( this.sceneOverlay , this.camera )

                    //}

                    //this.renderer.render( ml.grid.getDots() , this.camera)
                }

            } else {

                console.log('model grid error')

            }

        }

        if (this.tool.isDisplayDotGrid()) {
            this.renderer.render(this.sceneLayer, this.camera)
        }
        //this.renderer.render( this.sceneOverlay , this.camera )

        // window.razorApp.tool.isDisplayDotGrid()



        /*
        if (this.sceneContainer.isSceneUnderlay())
            this.renderer.render( this.sceneContainer.getSceneUnderlay( ) , this.camera )

        if (this.sceneContainer.isScene()) {

            for (let i = 0 ; i < this.sceneContainer.count() ; i++ ) {

                // rendering of mesh not scenes... ?!?..

                //console.log(' render ' + i)//container test


                this.renderMaskPrepare()

                if (this.sceneContainer.isSceneMask())
                    this.renderer.render( this.sceneContainer.getSceneMask( i ), this.camera )

                this.renderMaskAfter()

                if (this.sceneContainer.isScene())
                    this.renderer.render( this.sceneContainer.getScene( i ) , this.camera)

                this.renderMaskEnd()

            }

        }

        // renders only one mapping control (the active one)
        if (this.sceneContainer.isSceneUnderlay()) {
            this.renderer.render( this.sceneContainer.getSceneOverlay( this.tool.getMappingActive() ).gridline , this.camera)
            this.renderer.render( this.sceneContainer.getSceneOverlay( this.tool.getMappingActive() ).dots , this.camera)

        }

        this.renderer.render( this.sceneUi , this.camera )
*/

        // save video
        if (this.capturer) {

            this.capturer.capture(this.renderer.domElement)   // canvas

        }

        // call update




        if (this.isDebug()) {
            this.stats.end()
        }

        requestAnimationFrame(() => this.render())


    }





    _renderMaskPrepare() {

        let gl = this.renderer.getContext()

        // https://stackoverflow.com/questions/35023275/three-js-usage-with-stencil-buffer
        // https://sites.google.com/site/cgwith3js/home/masking-with-stencil

        gl.clearStencil(0)
        gl.clear(gl.STENCIL_BUFFER_BIT)

        // Replacing the values at the stencil buffer to 1 on every pixel we draw
        gl.stencilFunc(gl.ALWAYS, 1, 1)
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE)

        // Disable color
        gl.colorMask(false, false, false, false)

        // Allow alpha - https://community.khronos.org/t/stencil-buffer-with-alpha-blending/26876/2
        //gl.enable(gl.SAMPLE_ALPHA_TO_COVERAGE)

        // Write to stencil
        gl.enable(gl.STENCIL_TEST)

    }


    _renderMaskAfter() {

        let gl = this.renderer.getContext()

        gl.stencilFunc(gl.EQUAL, 1, 1)
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP)

        // Clear depth buffer (seems important)
        this.renderer.clearDepth()

        // Enable color
        gl.colorMask(true, true, true, true)

    }


    _renderMaskEnd() {

        let gl = this.renderer.getContext()

        // Disable stencil test
        gl.disable(gl.STENCIL_TEST)

    }



}

